module.exports = __webpack_public_path__ + "static/img/03.f16f77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/03.jpg
// module id = pRQa
// module chunks = 0